import { createSelector } from 'reselect'
import storeSearchResultsSelector from './store_search_results_selector'

import viewTypes from 'helpers/enums/viewTypes'
import searchStatuses from 'helpers/enums/storeSearchStatuses'

const getStore = state => state.store
const getLessons = state => state.lessons
const getUI = state => state.ui

const storeFolderContainerSelector = createSelector(
	[ getStore, getLessons, getUI, storeSearchResultsSelector ],
	(storeData, lessonsData, uiData, resultsData) => {

		const lessons = storeData.results.map(entityUID => lessonsData[entityUID])
		const hasMoreResults = storeData.hasMoreResults && storeData.searchStatus === searchStatuses.READY && storeData.results.length !== 0
		const showLoadingMore = storeData.searchStatus === searchStatuses.LOADING_MORE

		return {
			query: storeData.query,
			container_width: uiData.width,
			hasMoreResults,
			folderName: storeData.folderTitle,
			lessons,
			useGridPadding: !(uiData.currentView && (uiData.currentView === viewTypes.STORE_FOLDER)),
			showPriceThumb: resultsData.showPriceThumb,
			showLoadingMore,
		}
	}
)

export default storeFolderContainerSelector
